// extracted by mini-css-extract-plugin
export default {"timer":"Timer_timer__NiuSn","box":"Timer_box__oIsqe","large":"Timer_large__Mx4nM","medium":"Timer_medium__XDPmj"};